import NavBar from './navbar'
import s from './styles.module.scss'
import { useState } from 'react'
import IncomingCallListener from './IncomingCallListener'

export default function Main({ children }) {
  const [fullscreen, setFullscreen] = useState(false)

  return (
    <>
      <div className={s.mainOuter + ' innerScroll'} id='scroll'>
        <div className={s.main}>
          <NavBar fullscreen={fullscreen} setFullscreen={setFullscreen} />
          <IncomingCallListener />
          {!fullscreen && <div className={s.content}>{children}</div>}
        </div>
      </div>
    </>
  )
}
